import { Component, ErrorInfo, ReactNode } from 'react';
import ErrorCode from '../../pages/errorCode';

type Props = {
  children: ReactNode;
};
type State = {
  hasError: boolean;
};

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, errorInfo);
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <ErrorCode
          code='Something went wrong...'
          message='This issue has been reported. Please click the button below to return to the dashboard.'
          to='/'
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
